// Cores do tema "Grafite" para os gráficos (Recharts precisa de valores JS).
// Espelha as variáveis de src/styles/theme.css — manter os dois em sincronia.
export const COLORS = {
  bg: '#0E0F13',
  card: '#1A1C22',
  border: '#2A2D36',
  text: '#F4F5F7',
  muted: '#8A8F9A',
  accent: '#6E7BF2',     // gasto (barras)
  conversas: '#23E0A1',  // conversas iniciadas (linha verde)
  custo: '#F5A623'       // custo por conversa (linha âmbar)
};

// Estilo padrão de tooltip escuro reutilizável nos gráficos.
export const tooltipStyle = {
  contentStyle: {
    background: '#1A1C22',
    border: '1px solid #2A2D36',
    borderRadius: 8,
    color: '#F4F5F7'
  },
  labelStyle: { color: '#8A8F9A' },
  itemStyle: { color: '#F4F5F7' }
};
